// TODO: improve import/type def [future release]
// eslint-disable-next-line import/no-unresolved
import { IconLibraryTypes } from '@liberty-financial/ng-components/lib/components/icon/library.enum';

export type SidebarVisibility = 'show' | 'coming' | 'hide';

export class SideBarItem {
  constructor(
    public readonly name: string,
    public readonly href: string,
    public readonly icon: IconLibraryTypes,
    public readonly visibility: SidebarVisibility = 'show'
  ) {}
}
